import { BlogContentSection } from "../../../mocks/blog";

interface ArticleContentProps {
  sections: BlogContentSection[];
}

export default function ArticleContent({ sections }: ArticleContentProps) {
  return (
    <div className="prose-custom">
      {sections.map((section, i) => {
        if (section.type === "paragraph") {
          return (
            <p
              key={i}
              className="font-body text-[#3a3a3a] text-base leading-[1.85] mb-6"
            >
              {section.text}
            </p>
          );
        }

        if (section.type === "heading") {
          return (
            <h2
              key={i}
              className="font-heading font-bold text-brand-black text-2xl leading-tight mt-10 mb-4 tracking-tight"
            >
              {section.text}
            </h2>
          );
        }

        if (section.type === "list" && section.items) {
          return (
            <ul key={i} className="mb-6 space-y-3 pl-1">
              {section.items.map((item, j) => (
                <li key={j} className="flex items-start gap-3">
                  <span
                    className="mt-2 w-2 h-2 rounded-full flex-shrink-0"
                    style={{ backgroundColor: "#E8150C" }}
                  ></span>
                  <span className="font-body text-[#3a3a3a] text-base leading-relaxed">
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          );
        }

        if (section.type === "quote") {
          return (
            <blockquote
              key={i}
              className="my-8 pl-6 border-l-4 py-1"
              style={{ borderColor: "#E8150C" }}
            >
              <p className="font-body text-brand-black text-lg leading-relaxed italic font-medium">
                {section.text}
              </p>
            </blockquote>
          );
        }

        return null;
      })}
    </div>
  );
}
